/* eslint-disable no-nested-ternary */
export const videoBitrateClass = (videoAverageKbps: number) =>
  videoAverageKbps > 600
    ? 'very-good'
    : videoAverageKbps > 400
    ? 'good'
    : videoAverageKbps > 200
    ? 'average'
    : 'bad';

export const audioBitrateClass = (audioAverageKbps: number) =>
  audioAverageKbps > 25
    ? 'very-good'
    : audioAverageKbps > 15
    ? 'good'
    : audioAverageKbps > 10
    ? 'average'
    : 'bad';

export const downloadSpeedIndex = (downloadSpeed: number) =>
  downloadSpeed > 20 ? 4 : downloadSpeed > 10 ? 3 : downloadSpeed > 5 ? 2 : 1;

export const uploadSpeedIndex = (uploadSpeed: number) =>
  uploadSpeed > 10 ? 4 : uploadSpeed > 8 ? 3 : uploadSpeed > 4 ? 2 : 1;

export const downloadSpeedClass = (downloadSpeed: number) =>
  downloadSpeed > 20
    ? 'very-good'
    : downloadSpeed > 10
    ? 'good'
    : downloadSpeed > 5
    ? 'average'
    : 'bad';

export const uploadSpeedClass = (uploadSpeed: number) =>
  uploadSpeed > 10
    ? 'very-good'
    : uploadSpeed > 8
    ? 'good'
    : uploadSpeed > 4
    ? 'average'
    : 'bad';
